import { DSGovFlex } from '@gov-nx/ui/web/Layout/DSGovFlex';
import { LayoutGap } from '@gov-nx/ui/web/Layout/LayoutGap';
import { Skeleton } from '../../Skeleton/Skeleton';

const RadioSkeleton = ({ width }: { width: string }) => (
	<DSGovFlex
		alignItems="center"
		gap="s"
		responsive="false">
		<Skeleton
			shape="circle"
			width="26px"
			height="26px"
		/>
		<Skeleton width={width} />
	</DSGovFlex>
);

export const AuthorizationSkeleton = () => (
	<LayoutGap gap="m">
		{/* "Pro autorizaci vyberte…" prompt */}
		<Skeleton width="280px" />
		{/* The three authorization method options */}
		<RadioSkeleton width="190px" />
		<RadioSkeleton width="150px" />
		<RadioSkeleton width="180px" />
	</LayoutGap>
);
